<template>
	<div class="inputContentBox">
		<yd-cell-group>
			<span class="title">{{title}}</span>
			<yd-cell-item>
				<yd-input
					slot="right"
					:type="type"
					:readonly="changeAble"
					required
					ref="input1"
					:show-clear-icon="false"
					:show-success-icon="false"
					:show-required-icon="false"
					:regex="regex"
					:max="max||30"
					:on-blur="checkEmpt"
					:on-focus="show"
					v-model="inputStr"
				></yd-input>
			</yd-cell-item>
		</yd-cell-group>
		<div class="tip" v-show="!isShow&&!inputStr" @click="changeShow()">{{text}}</div>
	</div>
</template>

<script>
	export default {
		name: "inputComponent",
		props: ["title", "text", "regex", "type", "value","max","changeAble"],
		data() {
			return {
				isShow: false,
			};
		},
		computed: {
			inputStr: {
				get: function () {
					return this.value;
				},
				set: function (val) {
					this.$emit("input", val);
				}
			}
		},
		methods: {
			show: function () {
				this.isShow = true;
			},
			changeShow: function () {
				if (!this.changeAble) {
					this.isShow = true;
					this.$refs.input1.setFocus();
				}
			},
			checkEmpt: function () {
				this.isShow = false;
				this.$common.revisePage();
			},
			checkSubmit: function () {
				var dom = this.$refs.input1;
				if (!dom.valid) {
					this.changeShow();
					this.$common.errTip(this.title + dom.errorMsg);
					return false;
				}
				return this.inputStr;
			}
		}
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/inputComponent/inputComponent.vue